import smartQueue from '@analytics/queue-utils';
import { getSession, getPageSession, getTabSession, setPageSession, setTabSession, setSession, extendSession } from '@analytics/session-utils';
import { isBrowser, isString, isBoolean } from '@analytics/type-utils';
import { uuid } from 'analytics-utils';
import deepmerge from 'deepmerge';
import { getItem, removeItem, setItem } from '@analytics/localstorage-utils';
import { AwsClient } from 'aws4fetch';
import { onUserActivity } from '@analytics/activity-utils';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty$1 = _defineProperty;

var defineProperty = defineProperty$1;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var objectSpread2 = _objectSpread2;

var _objectSpread = objectSpread2;

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
}(runtime));

var regenerator = runtime.exports;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof_1 = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof_1 = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var _typeof_1 = _typeof;

var _typeof$1 = _typeof_1;

var OBJ_TYPE = 'object';
var STR_TYPE = 'string';
var UNKNOWN = '?';
var NAME = 'name';
var VERSION = 'version';
var EMPTY = '';
var FUNC_TYPE = 'function';
var UNDEF_TYPE = 'undefined';
var BLACKBERRY = 'BlackBerry',
    CHROME = 'Chrome',
    FIREFOX = 'Firefox';
var windowsVersionMap = {
  'ME': '4.90',
  'NT 3.11': 'NT3.51',
  'NT 4.0': 'NT4.0',
  '2000': 'NT 5.0',
  'XP': ['NT 5.1', 'NT 5.2'],
  'Vista': 'NT 6.0',
  '7': 'NT 6.1',
  '8': 'NT 6.2',
  '8.1': 'NT 6.3',
  '10': ['NT 6.4', 'NT 10.0'],
  'RT': 'ARM'
};
var os = [[
/* Windows */
// Windows (iTunes)
/microsoft (windows) (vista|xp)/i], [NAME, VERSION], // Windows RT
[/(windows) nt 6\.2; (arm)/i, // Windows Phone                                       
/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]],
/* iOS/macOS */
// iOS
[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], // Mac OS
[/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[NAME, 'MacOS'], [VERSION, /_/g, '.']],
/*  Mobile OSes */
// Android-x86
[/droid ([\w\.]+)\b.+(android[- ]x86)/i], [VERSION, NAME], // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, // Blackberry
/(blackberry)\w*\/([\w\.]*)/i, // Tizen/KaiOS
/(tizen|kaios)[\/ ]([\w\.]+)/i, // Series 40
/\((series40);/i], [NAME, VERSION], // BlackBerry 10
[/\(bb(10);/i], [VERSION, [NAME, BLACKBERRY]], // Firefox OS
[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [VERSION, [NAME, FIREFOX + ' OS']], // WebOS
[/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [VERSION, [NAME, 'webOS']], // Google Chromecast
[/crkey\/([\d\.]+)/i], // Google Chromecast
[VERSION, [NAME, CHROME + 'cast']], // Chromium OS
[/(cros) [\w]+ ([\w\.]+\w)/i], [[NAME, 'Chromium OS'], VERSION], // Other
[// Mageia/VectorLinux
/(mageia|vectorlinux)[; ]/i, // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, // Hurd/Linux
/(hurd|linux) ?([\w\.]*)/i, // GNU
/(gnu) ?([\w\.]*)/i, // UNIX
/(unix) ?([\w\.]*)/i], [NAME, VERSION]];

function rgxMapper(ua, arrays) {
  var i = 0,
      j,
      k,
      p,
      q,
      matches,
      match; // loop through all regexes maps

  while (i < arrays.length && !matches) {
    var regex = arrays[i],
        // even sequence (0,2,4,..)
    props = arrays[i + 1]; // odd sequence (1,3,5,..)

    j = k = 0; // try matching uastring with regexes

    while (j < regex.length && !matches) {
      matches = regex[j++].exec(ua);

      if (!!matches) {
        for (p = 0; p < props.length; p++) {
          match = matches[++k];
          q = props[p]; // check if given property is actually array

          if (_typeof$1(q) === OBJ_TYPE && q.length > 0) {
            if (q.length == 2) {
              if (_typeof$1(q[1]) == FUNC_TYPE) {
                // assign modified match
                this[q[0]] = q[1].call(this, match);
              } else {
                // assign given value, ignore regex match
                this[q[0]] = q[1];
              }
            } else if (q.length == 3) {
              // check whether function or regex
              if (_typeof$1(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                // call function (usually string mapper)
                this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
              } else {
                // sanitize match using given regex
                this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
              }
            } else if (q.length == 4) {
              this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
            }
          } else {
            this[q] = match ? match : undefined;
          }
        }
      }
    }

    i += 2;
  }
}

function strMapper(str, map) {
  for (var i in map) {
    // check if current value is array
    if (_typeof$1(map[i]) === OBJ_TYPE && map[i].length > 0) {
      for (var j = 0; j < map[i].length; j++) {
        if (has(map[i][j], str)) {
          return i === UNKNOWN ? undefined : i;
        }
      }
    } else if (has(map[i], str)) {
      return i === UNKNOWN ? undefined : i;
    }
  }

  return str;
}

function has(str1, str2) {
  return _typeof$1(str1) === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
}

function lowerize(str) {
  return str.toLowerCase();
}

function getOS(ua) {
  var _ua = ua || ((typeof window === "undefined" ? "undefined" : _typeof$1(window)) !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);

  var _os = {};
  _os[NAME] = undefined;
  _os[VERSION] = undefined;
  rgxMapper.call(_os, _ua, os);
  return _os;
}

var BRAVE = 'Brave';
function browserClientInfo() {
  if (typeof window === 'undefined') {
    return {};
  }

  if (!window.navigator) {
    return {};
  }

  var _window$navigator = window.navigator,
      platform = _window$navigator.platform,
      product = _window$navigator.product,
      vendor = _window$navigator.vendor;

  var _browserType = browserType(window.navigator),
      type = _browserType.type,
      version = _browserType.version;

  var vender = type === BRAVE ? type : (vendor || '').split(' ')[0];
  return {
    platform: platform,
    os: getOS(),
    make: vender || product,
    // product always gecko
    model: type,
    version: version,
    name: [type, version].join('/'),
    language: getLanguage(),
    timezone: browserTimezone()
  };
}

function getLanguage() {
  var _window$navigator2 = window.navigator,
      language = _window$navigator2.language,
      browserLanguage = _window$navigator2.browserLanguage,
      languages = _window$navigator2.languages;
  return (language || browserLanguage || (languages || ['en_US'])[0]).toLowerCase().replace('-', '_');
}

function browserTimezone() {
  var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
  return tzMatch ? tzMatch[1] || '' : '';
}

function browserType(navigator) {
  var userAgent = navigator.userAgent;
  var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);

  if (operaMatch) {
    return {
      type: operaMatch[1],
      version: operaMatch[2]
    };
  }

  var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);

  if (ieMatch) {
    return {
      type: ieMatch[1],
      version: ieMatch[2]
    };
  } // headless chrome


  var headless = /(headlesschrome)(?:\/([\w\.]+)| )/i.exec(userAgent);

  if (headless) {
    return {
      type: headless[1],
      version: headless[2]
    };
  }

  var chromeMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);

  if (chromeMatch) {
    var isBrave = navigator.brave && navigator.brave.isBrave || false;
    return {
      type: isBrave ? BRAVE : chromeMatch[1],
      version: chromeMatch[2]
    };
  }

  var safariMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);

  if (safariMatch) {
    return {
      type: safariMatch[1],
      version: safariMatch[2]
    };
  }

  var webkitMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);

  if (webkitMatch) {
    return {
      type: webkitMatch[1],
      version: webkitMatch[2]
    };
  }

  var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
  var fallback = anyMatch || ['', 'NA', '0.0.0'];
  return {
    type: fallback[1],
    version: fallback[2]
  };
}

function getEventName(key) {
  var eventMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return eventMap[key] || key;
}

function prepareAttributes(_x) {
  return _prepareAttributes.apply(this, arguments);
}
/**
 * Prepares an object for inclusion in endpoint data or event data.
 *
 * @param {Object} metrics
 */

function _prepareAttributes() {
  _prepareAttributes = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(attributes) {
    var asArray,
        sanitized,
        name,
        value,
        prepValue,
        data,
        _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            asArray = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            sanitized = {};
            _context.t0 = regenerator.keys(attributes);

          case 3:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 13;
              break;
            }

            name = _context.t1.value;
            value = Array.isArray(attributes[name]) ? attributes[name] : [attributes[name]];
            prepValue = asArray ? value : value[0]; // console.log(`name ${name}`, prepValue)

            _context.next = 9;
            return prepareData(prepValue, sanitizeAttribute);

          case 9:
            data = _context.sent;

            /* Remove any null/undefined values */
            if (!isNullOrUndef(data)) {
              sanitized[name] = data;
            }

            _context.next = 3;
            break;

          case 13:
            return _context.abrupt("return", sanitized);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _prepareAttributes.apply(this, arguments);
}

function prepareMetrics(_x2) {
  return _prepareMetrics.apply(this, arguments);
}
/**
 * Resolves an attribute or metric value and sanitize it.
 *
 * @param {mixed} value
 * @param {Function} sanitizeCallback
 */

function _prepareMetrics() {
  _prepareMetrics = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(metrics) {
    var sanitized, name;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sanitized = {};
            _context2.t0 = regenerator.keys(metrics);

          case 2:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 9;
              break;
            }

            name = _context2.t1.value;
            _context2.next = 6;
            return prepareData(metrics[name], sanitizeMetric);

          case 6:
            sanitized[name] = _context2.sent;
            _context2.next = 2;
            break;

          case 9:
            return _context2.abrupt("return", sanitized);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _prepareMetrics.apply(this, arguments);
}

function prepareData(_x3, _x4) {
  return _prepareData.apply(this, arguments);
}
/**
 * Ensure value is a string or array of strings.
 *
 * @param {mixed} value
 */


function _prepareData() {
  _prepareData = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(value, sanitizeCallback) {
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(typeof value === 'function')) {
              _context3.next = 4;
              break;
            }

            _context3.next = 3;
            return value();

          case 3:
            value = _context3.sent;

          case 4:
            return _context3.abrupt("return", sanitizeCallback(value));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _prepareData.apply(this, arguments);
}

function sanitizeAttribute(value) {
  // If null or undefined
  if (value == null) return;

  if (Array.isArray(value)) {
    return value.filter(notEmpty).map(function (val) {
      return val.toString();
    });
  } // @TODO guard against null here


  return isNullOrUndef(value) ? value : value.toString();
}
/**
 * Ensure value is a single float.
 *
 * @param {mixed} value
 */


function sanitizeMetric(value) {
  return parseFloat(Number(Array.isArray(value) ? value[0] : value));
}

function notEmpty(val) {
  return val !== null && typeof val !== 'undefined';
}

function isNullOrUndef(value) {
  return value == null;
}

/* The endpoint began a new session. */
var SESSION_START$1 = '_session.start';
/* The endpoint ended a session. */

var SESSION_STOP$2 = '_session.stop';
/* The endpoint paused a session. Paused sessions can be resumed so that you can continue to collect metrics without starting an entirely new session. */

var SESSION_PAUSE = '_session.pause';
/* The endpoint resumed a session. */

var SESSION_RESUME = '_session.resume';
/* The endpoint logged in to your app. */

var AUTH_SIGN_IN = '_userauth.sign_in';
/* A new endpoint completed the registration process in your app. */

var AUTH_SIGN_UP = '_userauth.sign_up';
/* The endpoint attempted to sign in to your app, but wasn't able to complete the process. */

var AUTH_FAIL = '_userauth.auth_fail';
/* The endpoint made a purchase in your app. */

var ECOM_PURCHASE = '_monetization.purchase';
/* The pageview event */

var PAGE_VIEW = 'pageView';

var events = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SESSION_START: SESSION_START$1,
  SESSION_STOP: SESSION_STOP$2,
  SESSION_PAUSE: SESSION_PAUSE,
  SESSION_RESUME: SESSION_RESUME,
  AUTH_SIGN_IN: AUTH_SIGN_IN,
  AUTH_SIGN_UP: AUTH_SIGN_UP,
  AUTH_FAIL: AUTH_FAIL,
  ECOM_PURCHASE: ECOM_PURCHASE,
  PAGE_VIEW: PAGE_VIEW
});

function formatEvent(_x) {
  return _formatEvent.apply(this, arguments);
}

function _formatEvent() {
  _formatEvent = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(eventName) {
    var data,
        config,
        appTitle,
        appPackageName,
        appVersionCode,
        eventMapping,
        enrichEventAttributes,
        enrichEventMetrics,
        debug,
        logger,
        type,
        sessionData,
        sessionId,
        sessionStart,
        sessionStartUnix,
        pageSessionInfo,
        tabSessionData,
        eventAttribs,
        eventId,
        time,
        timeStamp,
        sessionDuration,
        defaultEventAttributes,
        extraAttributes,
        eventAttributes,
        userDefinedMetrics,
        defaultMetrics,
        extraMetrics,
        eventMetrics,
        preparedData,
        eventPayload,
        _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            appTitle = config.appTitle, appPackageName = config.appPackageName, appVersionCode = config.appVersionCode, eventMapping = config.eventMapping, enrichEventAttributes = config.enrichEventAttributes, enrichEventMetrics = config.enrichEventMetrics, debug = config.debug;
            logger = debug ? console.log : function () {};
            type = getEventName(eventName, eventMapping);
            sessionData = getSession(); // @TODO refactor session grabber

            sessionId = data.sessionId || sessionData.id;
            sessionStart = data.sessionStart || sessionData.createdAt;
            sessionStartUnix = data.sessionStart ? new Date(data.sessionStart).getTime() : sessionData.created;
            logger('event sessionData    ', JSON.stringify(sessionData));

            if (isBrowser) {
              pageSessionInfo = getPageSession();
              tabSessionData = getTabSession();
              logger('event pageSessionInfo', JSON.stringify(pageSessionInfo));
              logger('event tabSessionData ', JSON.stringify(tabSessionData));
            }

            eventAttribs = data.attributes || {};
            eventId = data.eventId || uuid();
            time = data.time ? new Date(data.time) : new Date();
            timeStamp = time.toISOString();
            sessionDuration = time.getTime() - sessionStartUnix;
            defaultEventAttributes = _objectSpread({
              date: timeStamp,
              sessionId: sessionId
            }, !isBrowser ? {} : {
              pageSession: pageSessionInfo.id
            });

            if (!enrichEventAttributes) {
              _context.next = 23;
              break;
            }

            _context.next = 20;
            return enrichEventAttributes();

          case 20:
            _context.t0 = _context.sent;
            _context.next = 24;
            break;

          case 23:
            _context.t0 = {};

          case 24:
            extraAttributes = _context.t0;

            /* Format attributes */
            eventAttributes = _objectSpread(_objectSpread(_objectSpread({}, defaultEventAttributes), extraAttributes), eventAttribs);
            /* Format metrics */
            // const elapsedSessionTime = elapsed + (time.getTime() - subSessionStart)

            userDefinedMetrics = data.metrics || {};
            defaultMetrics = {
              /* Time of session */
              sessionTime: sessionData.elapsed || sessionDuration,

              /* Date metrics */
              hour: time.getHours(),
              day: time.getDay() + 1,
              month: time.getMonth() + 1,
              year: time.getFullYear()
            };

            if (!enrichEventMetrics) {
              _context.next = 34;
              break;
            }

            _context.next = 31;
            return enrichEventMetrics();

          case 31:
            _context.t1 = _context.sent;
            _context.next = 35;
            break;

          case 34:
            _context.t1 = {};

          case 35:
            extraMetrics = _context.t1;
            eventMetrics = _objectSpread(_objectSpread(_objectSpread({}, defaultMetrics), extraMetrics), userDefinedMetrics);
            _context.next = 39;
            return prepareAttributes(eventAttributes);

          case 39:
            _context.t2 = _context.sent;
            _context.next = 42;
            return prepareMetrics(eventMetrics);

          case 42:
            _context.t3 = _context.sent;
            preparedData = {
              attributes: _context.t2,
              metrics: _context.t3
            };
            logger("".concat(eventId, ":").concat(type));
            logger('eventAttributes', preparedData.attributes);
            logger('eventMetrics', preparedData.metrics);

            if (isBrowser) {
              logger('clientInfo', browserClientInfo());
            } // const appVersionCodeString = getAppVersionCode(config)
            // https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/Pinpoint.html#putEvents-property


            eventPayload = defineProperty$1({}, eventId, _objectSpread(_objectSpread({
              /* The name of the event */
              EventType: type,

              /* The date and time, in ISO 8601 format, when the event occurred. */
              Timestamp: timeStamp,

              /* The package name of the app that's recording the event. */
              AppPackageName: appPackageName,

              /* The title of the app that's recording the event. */
              AppTitle: appTitle
            }, appVersionCode ? {
              AppVersionCode: appVersionCode
            } : {}), {}, {
              /* Event attributes - One or more custom attributes that are associated with the event. */
              Attributes: preparedData.attributes,

              /* The version of the SDK that's running on the client device. */
              // ClientSdkVersion: 'STRING_VALUE',

              /* The name of the SDK that's being used to record the event. */
              // SdkName: 'STRING_VALUE',

              /* Event metrics - One or more custom metrics that are associated with the event. */
              Metrics: preparedData.metrics,
              Session: {
                /* SessionId is required */
                Id: sessionId,

                /* StartTimestamp is required */
                StartTimestamp: sessionStart // ISOString

              }
            })); // Add session stop parameters.

            if (eventName === SESSION_STOP$2) {
              // eventPayload[eventId].Session.Duration = Date.now() - subSessionStart
              // console.log('Old DURATION', Date.now() - subSessionStart)
              eventPayload[eventId].Session.Duration = sessionDuration; // sessionData.elapsed was slightly off

              eventPayload[eventId].Session.StopTimestamp = timeStamp;
            }

            return _context.abrupt("return", eventPayload);

          case 51:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _formatEvent.apply(this, arguments);
}

var ENDPOINT_KEY$1 = '__endpoint';
function getStorageKey(id) {
  return "".concat(ENDPOINT_KEY$1, ".").concat(id);
}

var ENDPOINT_KEY = '__endpoint';
var migrationRan = false;
function mergeEndpointData() {
  return _mergeEndpointData.apply(this, arguments);
}

function _mergeEndpointData() {
  _mergeEndpointData = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var endpoint,
        config,
        getUserId,
        getEndpointId,
        endpointMigration,
        context,
        sessionKey,
        pageKey,
        pageSessionInfo,
        pageSession,
        clientInfo,
        sessionData,
        id,
        deprecatedData,
        persistedEndpoint,
        appVersionString,
        demographicInfo,
        EndpointData,
        foundId,
        _foundId,
        hasPreviousSession,
        _args = arguments;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpoint = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            getUserId = config.getUserId, getEndpointId = config.getEndpointId, endpointMigration = config.endpointMigration;
            context = grabContext(config);
            sessionKey = context.sessionKey ? context.sessionKey() : 'sessions';
            pageKey = context.pageViewKey ? context.pageViewKey() : 'pageViews'; // const tabSessionInfo = getTabSession()

            if (isBrowser) {
              clientInfo = browserClientInfo();
              pageSessionInfo = getPageSession();
              pageSession = pageSessionInfo.id;
            }

            sessionData = getSession();
            _context.next = 10;
            return getEndpointId();

          case 10:
            id = _context.sent;

            // @TODO remove in next version
            if (!migrationRan) {
              migrationRan = true; // Backwards compatible endpoint info

              deprecatedData = getItem(ENDPOINT_KEY); // clear out old key value

              if (deprecatedData) {
                persistEndpoint(id, deprecatedData); // remove old key

                removeItem(ENDPOINT_KEY);
              }
            }

            persistedEndpoint = getEndpoint$1(id); // const browserVersion = [clientInfo.model, clientInfo.version].join('/')

            appVersionString = getAppVersionCode(config);
            demographicInfo = getDemographicInfo(appVersionString, clientInfo); // console.log('demographicInfo', demographicInfo)

            EndpointData = {
              Attributes: {},
              Demographic: demographicInfo,
              Location: {
                /*
                City: 'STRING_VALUE',
                Country: 'STRING_VALUE',
                Latitude: 'NUMBER_VALUE',
                Longitude: 'NUMBER_VALUE',
                PostalCode: 'STRING_VALUE',
                Region: 'STRING_VALUE'
                */
              },
              Metrics: {// [`${sessionKey}Unix`]: sessionData.Unix
              }
              /** Indicates whether a user has opted out of receiving messages with one of the following values:
               * ALL - User has opted out of all messages.
               * NONE - Users has not opted out and receives all messages.
               */
              // OptOut: 'STRING_VALUE',

            };
            /* Add device attributes to endpoint */

            if (isBrowser) {
              if (clientInfo.device && clientInfo.device.vendor) {
                EndpointData.Attributes.DeviceMake = [clientInfo.device.vendor];
              }

              if (clientInfo.device && clientInfo.device.model) {
                EndpointData.Attributes.DeviceModel = [clientInfo.device.model];
              }

              if (clientInfo.device && clientInfo.device.type) {
                EndpointData.Attributes.DeviceType = [clientInfo.device.type];
              }
              /*
              if (endpoint.channelType && clientInfo.os.version) {
                EndpointData.ChannelType = endpoint.channelType
              }
              */

            }
            /* Merge new endpoint data with defaults. */


            endpoint = deepmerge.all([persistedEndpoint, EndpointData, endpoint], {
              arrayMerge: overwriteMerge // TODO maybe change array merge

            }); // Sync user ID if it's changed

            if (!(endpoint.User && endpoint.User.UserId)) {
              _context.next = 23;
              break;
            }

            _context.next = 21;
            return getUserId();

          case 21:
            foundId = _context.sent;

            if (endpoint.User.UserId !== foundId) {
              endpoint.User.UserId = foundId;
            }

          case 23:
            if (!(!endpoint.User || !endpoint.User.UserId)) {
              _context.next = 28;
              break;
            }

            _context.next = 26;
            return getUserId();

          case 26:
            _foundId = _context.sent;

            if (_foundId) {
              endpoint.User = endpoint.User || {};
              endpoint.User.UserId = _foundId;
            }

          case 28:
            if (!(endpoint.User && endpoint.User.UserAttributes)) {
              _context.next = 32;
              break;
            }

            _context.next = 31;
            return prepareAttributes(endpoint.User.UserAttributes, true);

          case 31:
            endpoint.User.UserAttributes = _context.sent;

          case 32:
            _context.next = 34;
            return prepareAttributes(endpoint.Attributes, true);

          case 34:
            endpoint.Attributes = _context.sent;
            _context.next = 37;
            return prepareMetrics(endpoint.Metrics);

          case 37:
            endpoint.Metrics = _context.sent;

            // console.log('endpoint.Metrics', endpoint.Metrics)

            /* Set initial session count */
            if (!endpoint.Metrics[sessionKey]) {
              endpoint.Metrics[sessionKey] = 1.0;
            }
            /* Set initial page view count */


            if (!endpoint.Metrics[pageKey]) {
              endpoint.Metrics[pageKey] = 1.0;
            }
            /* Custom data migration function */


            if (endpointMigration) {
              endpoint = endpointMigration(id, endpoint);
            }
            /* If this is first session, set values and return */


            hasPreviousSession = endpoint.Attributes.lastSession;

            if (hasPreviousSession) {
              _context.next = 47;
              break;
            }

            endpoint.Attributes.lastSessionDate = [sessionData.createdAt];
            endpoint.Attributes.lastSession = [sessionData.id]; // @TODO persist tab info
            // endpoint.Attributes.lastTabSession = [ tabSessionInfo.id ]

            if (pageSession) {
              endpoint.Attributes.lastPageSession = [pageSession];
            } // Store the endpoint data.
            // console.log('Set initital endpoint info')


            return _context.abrupt("return", persistEndpoint(id, endpoint));

          case 47:
            /* If current sessionId is different than lastSession */
            if (hasPreviousSession && hasPreviousSession[0] !== sessionData.id) {
              endpoint.Attributes.lastSessionDate = [sessionData.createdAt];
              endpoint.Attributes.lastSession = [sessionData.id];
              endpoint.Metrics[sessionKey] += 1.0; // console.log('Update lastSession info', sessionData.id)
            } // Increment pageViews.


            if (endpoint.Attributes.lastPageSession[0] !== pageSession) {
              endpoint.Attributes.lastPageSession = [pageSession];
              endpoint.Metrics[pageKey] += 1.0; // console.log('Update lastPageSession info', pageSession)
            } // Store the endpoint data.


            return _context.abrupt("return", persistEndpoint(id, endpoint));

          case 50:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mergeEndpointData.apply(this, arguments);
}

function persistEndpoint(id, endpointData) {
  var endpointKey = getStorageKey(id);
  var data = isString(endpointData) ? endpointData : JSON.stringify(endpointData);
  setItem(endpointKey, data);
  return endpointData;
}

function getEndpoint$1(id) {
  try {
    return JSON.parse(getItem(getStorageKey(id))) || {};
  } catch (error) {}

  return {};
}

function getDemographicInfo(appVersionString, clientInfo) {
  return isBrowser ? getBrowserDemographicInfo(appVersionString, clientInfo) : getServerDemographicInfo(appVersionString);
}

function getServerDemographicInfo(appVersionString) {
  var demographicInfo = {
    AppVersion: appVersionString,
    Make: 'generic server',
    Platform: 'Node.js',
    PlatformVersion: process.version
  };
  return demographicInfo;
}

function getBrowserDemographicInfo(appVersionString, clientInfo) {
  var demographicInfo = {
    // AppTitle/0.0.0. Maps to application.version_name in kinesis stream
    AppVersion: appVersionString,

    /* The locale of the endpoint, in the following format: 
       the ISO 639-1 alpha-2 code, followed by an underscore (_), 
       followed by an ISO 3166-1 alpha-2 value. 
    */
    Locale: clientInfo.language,
    // Maker - Google/Mozilla/Apple
    Make: clientInfo.make,
    // Model - Safari/Chrome/Brave/Opera
    Model: clientInfo.model,
    // ModelVersion - 91.0.0
    ModelVersion: clientInfo.version,
    // Platform - os name
    Platform: clientInfo.os.name || clientInfo.platform // PlatformVersion: browserVersion,
    // Timezone: 'STRING_VALUE'

  };

  if (clientInfo.os && clientInfo.os.version) {
    demographicInfo.PlatformVersion = clientInfo.os.version;
  }

  return demographicInfo;
}

function getAppVersionCode(config) {
  var appName = config.appTitle || config.appPackageName || '';
  var appVersion = config.appVersionCode || '0.0.0';
  return appName ? "".concat(appName, "@").concat(appVersion) : appVersion;
}
/**
 * Array merge function for deepmerge.
 *
 * @param {Array} destinationArray
 * @param {Array} sourceArray
 */


function overwriteMerge(_destinationArray, sourceArray) {
  return sourceArray;
}

function grabContext(_ref) {
  var getContext = _ref.getContext;

  if (typeof getContext === 'function') {
    return getContext();
  }

  return getContext;
}

function createEventQueue(queue) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _queueEvent = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(eventName) {
      var eventData,
          endpoint,
          flush,
          eventPayload,
          _args = arguments;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              eventData = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              endpoint = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              flush = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;

              if (isBoolean(eventData)) {
                eventData = {};
                flush = eventData;
              }

              if (isBoolean(endpoint)) {
                endpoint = {};
                flush = endpoint;
              }

              _context.next = 7;
              return formatEvent(eventName, eventData, config);

            case 7:
              eventPayload = _context.sent;

              if (!(Object.entries(endpoint).length || eventName === PAGE_VIEW)) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return mergeEndpointData(endpoint, config);

            case 11:
              endpoint = _context.sent;

            case 12:


              queue.push(eventPayload); // If config setting to send every event as it happens

              if (!flush) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return", queue.flush());

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function queueEvent(_x) {
      return _queueEvent.apply(this, arguments);
    }

    return queueEvent;
  }();
}

var AWS;

var RETRYABLE_CODES = [429, 500];
var ACCEPTED_CODES = [202];
var BAD_REQUEST_CODE = 400;
function callAws(_x, _x2) {
  return _callAws.apply(this, arguments);
}

function _callAws() {
  _callAws = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(eventsRequest, config) {
    var pinpointRegion, pinpointAppId, lambdaArn, lambdaRegion, credentials, getCredentials, debug, auth, lambda_region, pinpoint_region, fips, LAMBDA_FN, PINPOINT_URL, endpointUrl, aws, data, payload, command, responses;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pinpointRegion = config.pinpointRegion, pinpointAppId = config.pinpointAppId, lambdaArn = config.lambdaArn, lambdaRegion = config.lambdaRegion, credentials = config.credentials, getCredentials = config.getCredentials, debug = config.debug;
            _context.next = 3;
            return getAuth(credentials, getCredentials);

          case 3:
            auth = _context.sent;

            if (debug) {
              console.log('pinpoint auth', auth);
            }

            lambda_region = lambdaRegion || pinpointRegion;
            pinpoint_region = pinpointRegion || lambdaRegion;
            fips = config.fips === true ? '-fips' : '';
            LAMBDA_FN = "https://lambda.".concat(lambda_region, ".amazonaws.com/2015-03-31/functions/").concat(lambdaArn, "/invocations");
            PINPOINT_URL = "https://pinpoint".concat(fips, ".").concat(pinpoint_region, ".amazonaws.com/v1/apps/").concat(pinpointAppId, "/events");
            endpointUrl = lambdaArn ? LAMBDA_FN : PINPOINT_URL;
            /* @TODO get beacon working with API gateway/lambda/pinpoint legacy endpoint
            function testBeacon() {
              return () => {
                sendBeaconRequest({
                  credentials: auth,
                  region: pinpoint_region,
                  pinpointAppId: pinpointAppId,
                  eventsRequest: eventsRequest,
                  // url: `https://pinpoint.${region}.amazonaws.com/v1/apps/${pinpointAppId}/events/legacy`;
                  url: LAMBDA_FN
                })
              }
            }
            window.testBeacon = testBeacon
            /**/

            payload = {
              body: JSON.stringify(eventsRequest)
            };

            aws = new AwsClient(auth);
            _context.next = 16;
            return aws.fetch(endpointUrl, payload).then(function (d) {
              return d.json();
            });

          case 16:
            data = _context.sent;
            _context.next = 24;
            break;

          case 19:
            aws = new AWS.PinpointClient({
              credentials: auth,
              region: pinpointRegion
            });
            command = new AWS.PutEventsCommand({
              ApplicationId: pinpointAppId,
              EventsRequest: eventsRequest
            });
            _context.next = 23;
            return aws.send(command);

          case 23:
            data = _context.sent;

          case 24:
            if (data && data.Results) {
              // Process api responses
              responses = Object.keys(data.Results).map(function (eventId) {
                return data.Results[eventId];
              });
              /* Message: "Session duration in milliseconds must be equal to the difference of start and stop timestamp"
              StatusCode: 400
              Session: {Id: "c024eae8-4978-4d2b-898d-31b89ddd62d3", StartTimestamp: "2021-05-25T06:09:30.632Z", Duration: 20008, StopTimestamp: "2021-05-25T06:09:50.641Z"}
              // new Date('2021-05-25T06:09:50.641Z').getTime() - new Date('2021-05-25T06:09:30.632Z').getTime() === 20009 */

              responses.forEach(function (resp) {
                var EndpointItemResponse = resp.EndpointItemResponse || {};
                var EventsItemResponse = resp.EventsItemResponse || {};

                if (Object.keys(EndpointItemResponse).length) {

                  if (ACCEPTED_CODES.includes(EndpointItemResponse.StatusCode)) ; else if (RETRYABLE_CODES.includes(EndpointItemResponse.StatusCode)) ; else {
                    // Try to handle error
                    handleEndpointUpdateBadRequest(EndpointItemResponse, Endpoint);
                  }
                }

                var events = Object.keys(EventsItemResponse);

                if (events.length) {

                  events.forEach(function (eventId) {// @TODO handle 400 errors
                    // console.log(`[req "${Endpoint.RequestId}"] Event id ${eventId}`, EventsItemResponse[eventId])
                  });
                }
              });
            }

            return _context.abrupt("return", data);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _callAws.apply(this, arguments);
}

function getAuth(_x3, _x4) {
  return _getAuth.apply(this, arguments);
}

function _getAuth() {
  _getAuth = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(credentials, getCredentials) {
    var creds, auth;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            creds = credentials;
            /* Use custom creds function */

            if (!(!Object.keys(creds).length && getCredentials)) {
              _context2.next = 11;
              break;
            }

            _context2.prev = 2;
            _context2.next = 5;
            return getCredentials();

          case 5:
            creds = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            throw new Error(_context2.t0);

          case 11:
            auth = {
              // Support amplify and raw client auth params
              accessKeyId: creds.accessKeyId || creds.AccessKeyId,
              secretAccessKey: creds.secretAccessKey || creds.SecretKey,
              sessionToken: creds.sessionToken || creds.SessionToken,
              retries: 5
            };
            return _context2.abrupt("return", auth);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 8]]);
  }));
  return _getAuth.apply(this, arguments);
}

function handleEndpointUpdateBadRequest(error, endpoint) {
  var StatusCode = error.StatusCode,
      Message = error.Message; // console.log('message', Message)

  if (StatusCode === BAD_REQUEST_CODE) {
    // 400
    if (Message.startsWith('Missing ChannelType')) {
      throw new Error('Missing ChannelType');
    }

    if (Message.startsWith('Exceeded maximum endpoint per user count')) {
      throw new Error('Exceeded maximum endpoint per user count');
    }
  }
}

var ALLOWED_CHANNELS = ['PUSH', 'GCM', 'APNS', 'APNS_SANDBOX', 'APNS_VOIP', 'APNS_VOIP_SANDBOX', 'ADM', 'SMS', 'VOICE', 'EMAIL', 'BAIDU', 'CUSTOM' // 'IN_APP' what is this?
];
var CHANNEL_TYPES = ALLOWED_CHANNELS.reduce(function (acc, curr) {
  acc[curr] = curr;
  return acc;
}, {});

var clientInfo = browserClientInfo();
var SESSION_START = SESSION_START$1,
    SESSION_STOP$1 = SESSION_STOP$2;
var EMAIL_REGEX = /.+\@.+\..+/;

function isEmail(string) {
  return EMAIL_REGEX.test(string);
}

function createPinpointSender() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getEndpointId = config.getEndpointId,
      debug = config.debug;
  return /*#__PURE__*/function () {
    var _pinpointPutEvent = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var eventsArray,
          endpointInfo,
          id,
          hasEndpoint,
          endpoint,
          channelType,
          events,
          eventsRequest,
          response,
          error,
          _args = arguments;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              eventsArray = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
              endpointInfo = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 4;
              return getEndpointId();

            case 4:
              id = _context.sent;

              if (id) {
                _context.next = 8;
                break;
              }

              console.error('No endpoint id. check getEndpointId()');
              return _context.abrupt("return");

            case 8:
              hasEndpoint = _typeof$1(endpointInfo) === 'object' && Object.keys(endpointInfo).length;

              if (hasEndpoint) {
                _context.next = 13;
                break;
              }

              _context.t0 = getEndpoint(id);
              _context.next = 16;
              break;

            case 13:
              _context.next = 15;
              return mergeEndpointData(endpointInfo, config);

            case 15:
              _context.t0 = _context.sent;

            case 16:
              endpoint = _context.t0;
              channelType = endpoint.ChannelType; // If email is set, set email channel

              if (endpoint.Address && isEmail(endpoint.Address)) {
                channelType = CHANNEL_TYPES.EMAIL;
              }

              if (!channelType && endpoint.Address) {
                if (clientInfo.platform === 'android') {
                  channelType = channelType || CHANNEL_TYPES.GCM;
                } else {
                  channelType = channelType || CHANNEL_TYPES.APNS;
                }
              }

              if (debug) {
                console.log('Endpoint', endpoint);
                console.log('CHANNEL_TYPE', channelType);
              } // Build endpoint data.


              endpoint.RequestId = uuid();
              endpoint.ChannelType = channelType;

              if (endpoint.Address) {
                // https://amzn.to/3bYC5gp
                // Default OptOut is ALL
                // OptOut: 'NONE',
                endpoint.OptOut = endpoint.OptOut || 'NONE';
              } // const endpointId = endpointId.replace(`${COGNITO_REGION}:`, '' )
              // Build events request object.


              events = sortEvents(eventsArray);
              eventsRequest = formatPinpointBody(id, endpoint, events); // console.log('New eventsRequest', eventsRequest)

              _context.prev = 26;
              _context.next = 29;
              return callAws(eventsRequest, config);

            case 29:
              response = _context.sent;
              _context.next = 36;
              break;

            case 32:
              _context.prev = 32;
              _context.t1 = _context["catch"](26);
              console.log('Error calling AWS', _context.t1);
              error = _context.t1;

            case 36:
              return _context.abrupt("return", {
                endpoint: endpoint,
                response: response,
                error: error,
                events: eventsArray
              });

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[26, 32]]);
    }));

    function pinpointPutEvent() {
      return _pinpointPutEvent.apply(this, arguments);
    }

    return pinpointPutEvent;
  }();
}

function getEndpoint(id) {
  try {
    return JSON.parse(getItem(getStorageKey(id))) || {};
  } catch (error) {}

  return {};
}

function sortEvents(events) {
  return events.sort(function (a, b) {
    var eventA = a.EventType;
    var eventB = b.EventType; // Send SESSION_START to front

    if (eventA == SESSION_START) return -1;
    if (eventB == SESSION_START) return 1; // Send SESSION_STOP to back

    if (eventA == SESSION_STOP$1) return 1;
    if (eventB == SESSION_STOP$1) return -1;
    return;
  }).reduce(function (acc, event) {
    return _objectSpread(_objectSpread({}, event), acc);
  }, {});
}

function formatPinpointBody(endpointId, endpoint, events) {
  return {
    BatchItem: defineProperty$1({}, endpointId, {
      Endpoint: endpoint,
      Events: events
    })
  };
}

var SESSION_STOP = SESSION_STOP$2;

function noOp() {
  return {};
}

function initialize() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // @TODO clean up
  var configuration = _objectSpread({
    getContext: config.getContext || noOp,
    credentials: config.credentials || {},
    getEndpointId: config.getEndpointId
  }, config);

  var logger = configuration.debug ? console.log : function () {}; // Create function that sends to pinpoint

  var pinpointPutEvent = createPinpointSender(configuration);
  var queue = smartQueue( /*#__PURE__*/function () {
    var _ref = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(events, rest) {
      var response;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              events.forEach(function (event) {
                return logger('> Queue event', event);
              });
              _context.next = 3;
              return pinpointPutEvent(events, {});

            case 3:
              response = _context.sent;
              logger('> Queue response', response);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), {
    max: 10,
    // limit... event limit is 100 for pinpoint
    interval: config.flushInterval || 3000,
    // 3s
    throttle: true // Ensure only max is processed at interval
    // onPause: (queue) => {},
    // onEmpty: () => {}

  });
  /* Create instance of recordEvent queue */

  var queueEvent = createEventQueue(queue, configuration);
  /* Run initialize endpoint merge */

  mergeEndpointData({}, config); // Flush remaining events on page close

  var detachUnloadListener = onWindowUnload(queueEvent);

  function updateEndpoint(endpoint) {
    // console.log('Call update immediately')
    return pinpointPutEvent([], endpoint);
  } // Function to detach listeners


  return {
    updateEndpoint: updateEndpoint,
    recordEvent: queueEvent,
    disable: function disable() {
      detachUnloadListener();
    }
  };
}

function onWindowUnload(queueEvent) {
  if (!isBrowser) {
    return noOp;
  }

  var stopSessionHandler = stopSessionFactory(queueEvent);
  window.addEventListener('beforeunload', stopSessionHandler);
  return function () {
    return window.removeEventListener('beforeunload', stopSessionHandler);
  };
}

function stopSessionFactory(queueEvent) {
  // Flush remaining events
  return function () {
    queueEvent(SESSION_STOP, true);
  };
}
/* @TODO wire up beacon */

/* mints URL like
https://pinpoint.us-east-1.amazonaws.com/v1/apps/undefined/events/legacy?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA5MJCKUDEZ7LNOGEQ%2F20210603%2Fus-east-1%2Fmobiletargeting%2Faws4_request&X-Amz-Date=20210603T072400Z&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEEAaCXVzLWVhc3QtMSJHMEUCIDXqsRUHXcYO7evSAbFndvriZLwsjgWE1K589Ls2VsjwAiEAyrwV8L9j44pSMnoPTctYI824WVMXq7sl%2BGe%2FtesfoNIqmgYI6f%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgw5MTk3MzE4NzE5NDUiDIahpd6Ez5lb38TwgCruBWM0LneAkgxPXtb%2B88hoXqpOyrLCWtuNiIBYyvpmfYTbOO%2Bw8JjmH9BVDcVdc2dyvzU4iFT4eX0tsRnJzKGzu6pdyYrGsj5H5vJgNw9muSKBXkEEv95OBTQHsC09kWayC4gNdeVbVzaSonwAtWln7VNT1SvdhT8UFCmm7xoBu1nYdwH49AF%2FHOC8PL69swK4pKzg3OQF5ioL%2B70%2FD1HHU51JD%2Bq5vNsupFZbgSqObopq52PM1FEs%2FlnsnbA8JdIe2IxZYKlz6Y6kL6evz3t5YlERTfI%2FG6jRAaTq0kl7OxQyCTqCb4JVfFFD%2BjVksFcOTyezgPhCcAsVqV0BPVZoeiv%2BysSlSjsiKKAUWHvH6GeUD5HtOT304%2F%2F2vT5I01tG0jHuAE%2BCvX5hm2xYN4VE9YFwFmHTFxBcNEKUjrflkmrnotOR5TTWW95VDm2MwUR1XEw8Ptuf4pr%2BLUXZ93UfiFG8edbupdCk71HNIfZeE85TNnh%2B1BDp0rVl9m15Jf2jf%2BlqddExqf82wnAe9MA8iPdIH%2Fqo7uyp75ev4Mjm90jlkBrL6LSk9g9dB9VFeDJing4J77pofuykVrZeTwpnEJQhUaqbU6Br1oVcogUtVfgSlh23Y9PjBx8%2BAfMC%2Ft0vhwnHSpb5NJGOcH6LWBUSpcBKaR7ZvZRWv4jVNKqT2jGPPAWUNbdueQgH1YT98X0jicmQm44u2to6MmINT0D8ZOG4qZc9PLu4wfI10toJMCg1QZ7BujIkPWgAMmOMtEsUri73CaID3tTpLhy6zzwrv%2B8NCOaKIMsFmsjC3IdJrOT15gcbV36sF682mBpvACWKzjnnPJo4NiwKsXk2kM%2FGa7kPF6R4VmtUfnJ2IIhxBaWVs4hxUJ82j1Dxp3DBJfBhEZUJb4ePRV07EJNC2iqTRQKgE8GpKSEJy838OkG2Md4i507iXwA8Q6j32OeaWY%2B%2F2oBorfgAIl8oKGMHhUyibX8M6rIvHKZnSENYaZaupTD4huKFBjqHAv9LIc9mjKVJ3BM0SzW8LDBc0jpMgccrAzgjGicP2iN%2FE%2B%2FauVMBHybr0dJQ7ixKOrp0QRxctEOmtv56FBF0md8T37xe7dwqt6mN94BnEOgZcz7k9uY9uXLS4nKan%2Fs7IFPzzduXlcdL4xbwLsdRcHrIaAyKiHzVI67jQlkr3dgW3ROQRRkJM4muccO29hopbtgfqamI3iTck2NDhCY%2B%2Bs8eZLtwmVV08A5DsdZqKcrePapltZO31e8ZSZEN6P3cnyPjTSuyvguPZWg1JAnFSBGAgMYmx7jmfcdULjb4L9KlJgcyTr5%2FQ2y8pUdi1wYTEMr%2FhhK%2FB2IjFOq78Uv8bj%2FtQmCbGMxN&X-Amz-SignedHeaders=host&X-Amz-Signature=a2304d65c0a894d736671a8b446a55f255e0745704c19ddd8951d265f39dcc7d
*/

/*
function sendBeaconRequest({ 
  credentials, 
  pinpointAppId, 
  region, 
  eventsRequest,
  url
}) {
	const accessInfo = {
		secret_key: credentials.secretAccessKey,
		access_key: credentials.accessKeyId,
		session_token: credentials.sessionToken,
	}
	const body = JSON.stringify(eventsRequest);
	const method = 'POST';

  // Pinpointt https://pinpoint.us-east-1.amazonaws.com/v1/apps/1111/events/legacy
	const request = {
		url,
		body,
		method,
	};

	const serviceInfo = { 
    region, 
    //service: 'mobiletargeting',
    service: 'lambda' 
  };

	const requestUrl = Signer.signUrl(
		request,
		accessInfo,
		serviceInfo,
		null
	);

	const success = navigator.sendBeacon(requestUrl, body);

	if (success) {
		return console.log('sendBeacon success');
	}
	return console.log('sendBeacon failure');
}
/**/

/* updateEndpoint usage:
updateEndpoint({
  "Address": 'test@gmail.com',
  "Attributes": { "lol": ['thing'], baz: 'bar' },
  "Demographic": {
    "AppVersion": string,
    "Locale": string,
    "Make": string,
    "Model": string,
    "ModelVersion": string,
    "Platform": string,
    "PlatformVersion": string,
    "Timezone": string
  },
  "Location": {
    "City": string,
    "Country": string,
    "Latitude": number,
    "Longitude": number,
    "PostalCode": string,
    "Region": string
  },
  "Metrics": { "key": 1 },
  "OptOut": 'NONE',
  "User": {
    "UserAttributes": { "key": 'baz', 'waht': ['chill'] },
    "UserId": 'user-123'
  }
})

// smaller example
updateEndpoint({
  "Address": 'jimbo@gmail.com',
  "Attributes": { "lol": ['thing'], baz: 'bar' },
  "Metrics": { "key": 1 },
  "OptOut": 'NONE',
  "User": {
    "UserAttributes": { "key": 'baz', 'waht': ['chill'] },
    "UserId": 'user-xyz'
  }
})
*/

function loadError() {
  throw new Error('Pinpoint not loaded');
}

function formatEventData(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var value = obj[key];

    if (typeof value === 'number') {
      acc.metrics[key] = value;
    }

    if (typeof value === 'string' || typeof value === 'boolean') {
      acc.attributes[key] = value;
    }

    return acc;
  }, {
    attributes: {},
    metrics: {}
  });
}

function bootstrap(pluginApi) {
  var config = pluginApi.config,
      instance = pluginApi.instance;
  /* Load aws-pinpoint script after userId exists */

  if (config && config.disableAnonymousTraffic && !instance.user('userId')) {
    instance.once('identifyStart', function (_ref) {
      var plugins = _ref.plugins;
      var self = plugins['aws-pinpoint'];

      if (!self.loaded()) {
        instance.loadPlugin('aws-pinpoint');
      }
    });
  }
}

// import { onScrollChange } from '@analytics/scroll-utils'
// @TODO turn on consent
// let hasAnonConsent = document.cookie.match(`__anon-consent=true`)
// let hasFullConsent = document.cookie.match(`__full-consent=true`)

var config = {
  /* Disable anonymous MTU */
  disableAnonymousTraffic: false,
  // Pinpoint service region
  pinpointRegion: 'us-east-1',
  // Custom event mapping
  eventMapping: {}
};
/**
 * AWS Pinpoint analytics integration
 * @link https://docs.aws.amazon.com/pinpoint/latest/developerguide/
 * @param {object} pluginConfig - Plugin settings
 * @param {string} pluginConfig.pinpointAppId - AWS Pinpoint app Id for client side tracking
 * @param {function} pluginConfig.getCredentials - Async function to get AWS Cognito creds
 * @param {string} [pluginConfig.pinpointRegion] - AWS Pinpoint region. Defaults to us-east-1
 * @param {string} [pluginConfig.appTitle] - The title of the app that's recording the event.
 * @param {string} [pluginConfig.appPackageName] - The name of the app package, such as com.example.my_app.
 * @param {string} [pluginConfig.appVersionCode] - The version number of the app, such as 3.2.0
 * @param {string} [pluginConfig.fips] - Use the AWS FIPS service endpoint for Pinpoint
 * @param {boolean} [pluginConfig.disableAnonymousTraffic] -  Disable anonymous events from firing
 * @return {object} Analytics plugin
 * @example
 *
 * awsPinpointPlugin({
 *   pinpointAppId: '938bebb1ae954e123133213160f2b3be4',
 *   getCredentials: () => Auth.currentCredentials(),
 * })
 */

function awsPinpointPlugin() {
  var pluginConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var recordEvent;
  var updateEndpoint;
  // let scrollDepthNow = 0

  /* Page-session (on route changes) */

  var hasPageFiredOnce = false;

  function stopSession() {
    var currentSessionData = getSession();

    if (pluginConfig.debug) {
      console.log('Stop session', currentSessionData);
    } // Fire session stop event.


    recordEvent(SESSION_STOP$2, true);
  } // window.stopSession = stopSession


  function startNewSession() {
    // Set new sessions.
    var newSession = setSession(30);

    if (pluginConfig.debug) {
      console.log('START SESSION', newSession);
    } // @TODO do we want this here?....
    // const pageSession = generatePageSession()

    /* Fire session start event. */


    recordEvent(SESSION_START$1);
  } // window.startSession = startNewSession

  /* return plugin */


  return {
    name: 'aws-pinpoint',
    config: _objectSpread(_objectSpread({}, config), pluginConfig),
    bootstrap: bootstrap,
    initialize: function initialize$1(_ref) {
      var config = _ref.config,
          instance = _ref.instance;
      var disableAnonymousTraffic = config.disableAnonymousTraffic,
          debug = config.debug;
      var logger = debug ? console.log : function () {};
      /* Disable pinpoint if user is not yet identified. */

      var state = instance.getState();
      var userDetails = state.user || {};
      var userId = userDetails.userId,
          anonymousId = userDetails.anonymousId;
      var context = state.context || {};
      var app = context.app,
          version = context.version,
          campaign = context.campaign;
      /* Initialize session info */

      var initPageSession = getPageSession();
      var initTabSession = getTabSession();
      var initSessionData = getSession();
      logger('initPageSession', initPageSession);
      logger('initTabSession', initTabSession);
      logger('initSessionData', initSessionData);
      /* If anonId has changed, refresh session details */

      if (initSessionData && initSessionData.anonId && initSessionData.anonId !== anonymousId) {
        logger('anonId different refresh session details'); // console.log('anonId', anonymousId)
        // console.log('initSessionData.anonId', initSessionData.anonId)

        /* Set new page session values */

        setPageSession();
        /* Set new tab session values */

        setTabSession();
        /* Set new session for new user */

        var newSessionForNewUser = setSession(30, {
          anonId: anonymousId,
          userId: userId
        });
        logger('newSessionForNewUser', newSessionForNewUser);
      }
      /* Disable for anonymous users */


      if (!userId && disableAnonymousTraffic) {
        return false;
      } // construct utm params


      var utmParams = Object.keys(campaign).reduce(function (acc, key) {
        acc["utm_".concat(key)] = campaign[key];
        return acc;
      }, {});
      /* Initialize pinpoint client */

      var pinpointClient = initialize(_objectSpread(_objectSpread({}, config), {}, {
        // The title of the app that's recording the event.
        appTitle: config.appTitle || app,
        // The package name of the app that's recording the event.
        appPackageName: config.appPackageName || app,
        // The version number of the app that's recording the event.
        appVersionCode: config.appVersionCode || version,
        // Custom event mapping
        eventMapping: config.eventMapping,
        // Get pinpoint endpoint ID
        getEndpointId: function getEndpointId() {
          return instance.user('anonymousId');
        },
        getUserId: function getUserId() {
          return instance.user('userId');
        },
        getContext: function getContext() {
          return {
            sessionKey: config.sessionKey,
            pageViewKey: config.pageViewKey,
            initialSession: initSessionData // scrollDepth: scrollDepthNow,
            // scrollDepthMax

          };
        },
        enrichEventAttributes: function enrichEventAttributes() {
          return _objectSpread({
            anonId: instance.user('anonymousId'),
            userId: instance.user('userId'),
            hash: window.location.hash,
            path: window.location.pathname,
            referrer: document.referrer,
            search: window.location.search,
            title: document.title,
            host: window.location.hostname,
            url: window.location.origin + window.location.pathname
          }, utmParams);
        },
        // Custom event mapping
        enrichUserAttributes: config.enrichUserAttributes,
        // Pass scroll into with all events
        enrichEventMetrics: function enrichEventMetrics() {
          return {};
          /* {
            scrollDepth: scrollDepthNow,
            scrollDepthMax
          }*/
        }
      }));

      recordEvent = pinpointClient.recordEvent;
      updateEndpoint = pinpointClient.updateEndpoint;

      if (initSessionData && initSessionData.isNew) {
        logger("Start brand new session because cookie not found");
        /* Start new session if its new */

        recordEvent(SESSION_START$1);
      }
      var THIRTY_MINUTES = 180e4; // 1800000ms

      var SESSION_LENGTH = THIRTY_MINUTES; // SESSION_LENGTH = 20000

      onUserActivity({
        timeout: SESSION_LENGTH,
        throttle: 20000,
        onIdle: function onIdle(activeTime, event) {
          logger("Session idle. Active ".concat(activeTime, " seconds")); // Stop session

          stopSession();
        },
        onWakeUp: function onWakeUp(idleTime, event) {
          logger("Session wakeup. Idle ".concat(idleTime, " seconds")); // Reset session info

          startNewSession();
        },
        onHeartbeat: function onHeartbeat(timeActive, event) {
          logger('ping session', new Date());
          logger('total active time', timeActive);
          /* Extend current session by 30 minutes */

          var user = instance.user();
          extendSession(30, {
            anonId: user.anonymousId,
            userId: user.userId
          });
        }
      });
      /* Old session handler
      tabListener = onTabChange((isHidden) => {
        console.log('isHidden', isHidden)
        if (isHidden) {
          stopSession()
        } else {
          console.log('Reset session!')
          startNewSession()
        }
      })*/

      /* Scroll tracking
      function pageScrolled(data) {
        const { trigger, direction, scrollMax, scrollMin, range } = data
        // Set current scroll values 
        scrollDepthNow = trigger
        scrollDepthMax = scrollMax
        // Record page scroll event 
        recordEvent('pageScrolled')
      }
      const detachScrollListener = onScrollChange({
        // 25: pageScrolled,
        50: pageScrolled,
        75: pageScrolled,
        90: pageScrolled
      })*/
    },
    page: function page(_ref2) {
      _ref2.payload;
          _ref2.config;

      if (!recordEvent) {
        return loadError();
      } // Fire page view and update pageSessionInfo Id


      if (hasPageFiredOnce) {
        // Set new page session values
        setPageSession();
      }

      recordEvent(PAGE_VIEW);
      hasPageFiredOnce = true;
    },

    /* Track event & update endpoint details */
    track: function track(_ref3) {
      var payload = _ref3.payload,
          config = _ref3.config;
          _ref3.instance;

      if (!recordEvent) {
        return loadError();
      }

      if (config.disableAnonymousTraffic && !payload.userId) {
        return;
      }

      var data = formatEventData(payload.properties);
      recordEvent(payload.event, data);
    },

    /* Update endpoint details */
    identify: function identify(_ref4) {
      var payload = _ref4.payload;
      var userId = payload.userId,
          traits = payload.traits;

      if (!updateEndpoint) {
        return loadError();
      }

      var endpoint = {};
      var userInfo = {};

      if (userId) {
        userInfo.UserId = userId;
      }

      if (traits && Object.keys(traits).length) {
        userInfo.UserAttributes = traits;
      }

      if (Object.keys(userInfo).length) {
        endpoint.User = userInfo;
      } // Update endpoint in AWS pinpoint


      updateEndpoint(endpoint, true);
    },

    /* Reset user details */
    reset: function reset(_ref5) {
      var instance = _ref5.instance;
      var id = instance.user('anonymousId');
      var key = getStorageKey(id);
      storage.removeItem(key);
    },
    loaded: function loaded() {
      return !!recordEvent;
    }
  };
}

/* This module will shake out unused code + work in browser and node 🎉 */

var index = awsPinpointPlugin ;

export { events as PINPOINT_EVENTS, index as default, formatEvent };
